<!-- Button cta do DS; como item de menu (Editar), usa o visual do mat-menu -->
<button type="button"
    [class.oa-btn]="appearance !== 'mat-menu-item'"
    [class.oa-btn--cta]="appearance !== 'mat-menu-item'"
    [class.mat-menu-item]="appearance === 'mat-menu-item'"
    [class.mat-focus-indicator]="appearance === 'mat-menu-item'"
    [attr.aria-label]="iconOnly ? label : null"
    [matTooltip]="iconOnly ? label : ''"
    (click)="onClick($event)">
    <ng-content></ng-content>
</button>
